const ACCESS_TOKEN_NAME = 'evincedAccessToken';
const ID_TOKEN_NAME = 'evincedIdToken';
const JIRA_ACCESS_TOKEN_NAME = 'jiraAccessToken';
const DASHBOARD_BANNER_DISMISSED = 'dashboardBannerDismissed';
const MFA_BANNER_DISMISSED = 'mfaBannerDismissed';
const MFA_BANNER_DISMISS_COUNT = 'mfaBannerDismissCount';
const MOBILE_SDK_BANNER_DISMISSED = 'mobileSdkBannerDismissed';
const MOBILE_SDK_BANNER_DISMISS_COUNT = 'mobileSdkBannerDismissCount';

export function getFromLocalStorage<T>(key: string): T {
	const item: string = localStorage.getItem(key);
	if (item) {
		return JSON.parse(item);
	}
	return null;
}

export function saveToLocalStorage<T>(key: string, value: T): void {
	localStorage.setItem(key, JSON.stringify(value));
}

export function deleteFromLocalStorage(key: string): void {
	localStorage.removeItem(key);
}

export function getAccessTokenFromLocalStorage(): string {
	return localStorage.getItem(ACCESS_TOKEN_NAME);
}

export function setAccessToken(token: string): void {
	localStorage.setItem(ACCESS_TOKEN_NAME, token);
}

export function getIdTokenFromLocalstorage(): string {
	return localStorage.getItem(ID_TOKEN_NAME);
}

export function setIdToken(token: string): void {
	localStorage.setItem(ID_TOKEN_NAME, token);
}

export function removeAuthenticationTokens(): void {
	localStorage.removeItem(ACCESS_TOKEN_NAME);
	localStorage.removeItem(ID_TOKEN_NAME);
}

export function removeValuesOnLogout(): void {
	removeAuthenticationTokens();
}

export function setJiraAccessToken(token): void {
	localStorage.setItem(JIRA_ACCESS_TOKEN_NAME, token);
}

export function getJiraAccessToken(): string {
	return localStorage.getItem(JIRA_ACCESS_TOKEN_NAME);
}

export function removeJiraAccessToken(): void {
	localStorage.removeItem(JIRA_ACCESS_TOKEN_NAME);
}

export const isDashboardBannerDismissed = (): boolean => {
	return localStorage.getItem(DASHBOARD_BANNER_DISMISSED) !== null;
};

export const setDashboardBannerDismissed = (dismissed: boolean): void => {
	if (dismissed) {
		localStorage.setItem(DASHBOARD_BANNER_DISMISSED, 'true');
	} else {
		localStorage.removeItem(DASHBOARD_BANNER_DISMISSED);
	}
};

export const isMfaBannerDismissed = (): boolean => {
	return localStorage.getItem(MFA_BANNER_DISMISSED) !== null;
};

export const setMfaBannerDismissed = (dismissed: boolean): void => {
	if (dismissed) {
		localStorage.setItem(MFA_BANNER_DISMISSED, 'true');
	} else {
		localStorage.removeItem(MFA_BANNER_DISMISSED);
	}
};

export const getMfaBannerDismissCount = (): number => {
	const count = localStorage.getItem(MFA_BANNER_DISMISS_COUNT);
	return count ? parseInt(count, 10) : 0;
};

export const incrementMfaBannerDismissCount = (): number => {
	const currentCount = getMfaBannerDismissCount();
	const newCount = currentCount + 1;
	localStorage.setItem(MFA_BANNER_DISMISS_COUNT, newCount.toString());
	return newCount;
};

export const resetMfaBannerDismissCount = (): void => {
	localStorage.removeItem(MFA_BANNER_DISMISS_COUNT);
};

export const isMobileSdkBannerDismissed = (): boolean => {
	return localStorage.getItem(MOBILE_SDK_BANNER_DISMISSED) !== null;
};

export const setMobileSdkBannerDismissed = (dismissed: boolean): void => {
	if (dismissed) {
		localStorage.setItem(MOBILE_SDK_BANNER_DISMISSED, 'true');
	} else {
		localStorage.removeItem(MOBILE_SDK_BANNER_DISMISSED);
	}
};

export const getMobileSdkBannerDismissCount = (): number => {
	const count = localStorage.getItem(MOBILE_SDK_BANNER_DISMISS_COUNT);
	return count ? parseInt(count, 10) : 0;
};

export const incrementMobileSdkBannerDismissCount = (): number => {
	const currentCount = getMobileSdkBannerDismissCount();
	const newCount = currentCount + 1;
	localStorage.setItem(MOBILE_SDK_BANNER_DISMISS_COUNT, newCount.toString());
	return newCount;
};

export const resetMobileSdkBannerDismissCount = (): void => {
	localStorage.removeItem(MOBILE_SDK_BANNER_DISMISS_COUNT);
};
